import { render, staticRenderFns } from "./ResultRowSummary.vue?vue&type=template&id=b0402c24&scoped=true"
import script from "./ResultRowSummary.vue?vue&type=script&lang=js"
export * from "./ResultRowSummary.vue?vue&type=script&lang=js"
import style0 from "./ResultRowSummary.vue?vue&type=style&index=0&id=b0402c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0402c24",
  null
  
)

export default component.exports